import React from 'react';
import invoiceTemplates from './invoiceTemplates';

const InvoiceRenderer = ({
    data,
    invoiceData,
    selectedPaymentType,
    selectedInvoiceType,
    selectedCopyType,
    getImageUrl
}) => {
    // Determine the format code — support both camelCase (frontend) and snake_case (from DB response)
    const company = data?.Company || data?.companyId || data?.company || {};
    const formatCode = (
        company?.invoiceFormat ||
        company?.invoice_format ||
        data?.invoiceFormat ||
        data?.invoice_format ||
        'format1'
    ).toLowerCase();

    // Fetch the correct template layout from registry
    const templateConfig = invoiceTemplates[formatCode] || invoiceTemplates.format1;
    const TemplateComponent = templateConfig.component;

    return (
        <TemplateComponent
            data={data}
            invoiceData={invoiceData}
            selectedPaymentType={selectedPaymentType}
            selectedInvoiceType={selectedInvoiceType}
            selectedCopyType={selectedCopyType}
            getImageUrl={getImageUrl}
        />
    );
};

export default InvoiceRenderer;
